// src/routes/index.js
import sales_team_routes from './sales-team'
export default [ sales_team_routes ]
